/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import {
	CosmosTextVariantEnum,
	LicenseSeatData,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
} from "@components/elements";
import { CosmosPageLicenseFragment } from "@cosmos/hygraph-schema";

import { LicenseCards } from "./LicenseCards.organism";
import { VStack } from "@panda/jsx";
import { css, cx } from "@panda/css";

export interface LicenseCardsSectionProps {
	locale: string;
	pageData?: CosmosPageLicenseFragment;
	seatsData1?: LicenseSeatData;
	seatsData2?: LicenseSeatData;
}

export const LicenseCardsSection = ({
	locale,
	pageData,
	seatsData1,
	seatsData2,
}: LicenseCardsSectionProps): React.JSX.Element => {
	return (
		<ResponsiveContainer>
			<SectionContainer>
				<VStack
					alignItems="start"
					gap="eds.dimension.48"
					className={cx("license-cards-section", css({ smDown: { gap: "eds.dimension.40" } }))}
				>
					<SectionHeading
						title={{ text: pageData?.title, as: "h1", variant: CosmosTextVariantEnum.heading2XL }}
						desc={pageData?.desc}
					/>
					<LicenseCards
						locale={locale}
						freeCardHeading={pageData?.freeCardHeading}
						freeCard={pageData?.freeCard}
						cardHeading={pageData?.cardHeading}
						showExampleLabel={pageData?.showExampleLabel}
						hideExampleLabel={pageData?.hideExampleLabel}
						mainCards={pageData?.mainCards || []}
						seatsData1={seatsData1}
						seatsData2={seatsData2}
						contactCard={pageData?.contactCard}
						contactCard2={pageData?.contactCard2}
					/>
				</VStack>
			</SectionContainer>
		</ResponsiveContainer>
	);
};
